export default class RoutesConstant {
    static HOME = '/';
    static SUBSCRIBE = '/subscribe';
    static DASHBOARD = '/dashboard';
}